import { useNavigate, type NavigateFunction } from "react-router-dom";
import { useRoutes } from "react-router-dom";
import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { onUnauthorized } from "@/services/api";
import routes from "./config";

let navigateResolver: (navigate: ReturnType<typeof useNavigate>) => void;

declare global {
  interface Window {
    REACT_APP_NAVIGATE: ReturnType<typeof useNavigate>;
  }
}

export const navigatePromise = new Promise<NavigateFunction>((resolve) => {
  navigateResolver = resolve;
});

export function AppRoutes() {
  const element = useRoutes(routes);
  const navigate = useNavigate();
  useEffect(() => {
    window.REACT_APP_NAVIGATE = navigate;
    navigateResolver(window.REACT_APP_NAVIGATE);
  });

  // An admin request came back 401: the token expired or was revoked.
  const queryClient = useQueryClient();
  useEffect(() => {
    onUnauthorized(() => {
      queryClient.clear();
      navigate("/admin/login", { replace: true, state: { expired: true } });
    });
    return () => onUnauthorized(null);
  }, [navigate, queryClient]);

  return element;
}
